import { createPinia } from 'pinia';
// import { createPersistedState } from 'pinia-plugin-persistedstate';

const store = createPinia();
// store.use(createPersistedState());

export { store };

export * from './modules/appsetting';
export * from './modules/signin';
export * from './modules/changpassword';
export * from './modules/forgetpassword';

export default store;
